module.exports = {
  login: '/api/tutor/login',
  logout: '/api/tutor/logout',
};
